import React from 'react';

const AriesIcon = ({ width = '80', height = '80', color = '#f1c40f' }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30 70C30 85 40 95 50 95C60 95 70 85 70 70" stroke={color} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M30 70C30 55 20 45 10 45" stroke={color} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M70 70C70 55 80 45 90 45" stroke={color} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="30" cy="70" r="7" fill={color}/>
    <circle cx="70" cy="70" r="7" fill={color}/>
  </svg>
);

export default AriesIcon;
